export const aboutUsConst = [
  {
    title: "Quality First",
    desc: "We ensure top-tier standards in every kitchen and every bite.",
    icon: "🥇",
  },
  {
    title: "Diversity & Inclusion",
    desc: "Celebrating culture through culinary variety from all backgrounds.",
    icon: "🌍",
  },
  {
    title: "Customer-Centric",
    desc: "Our users are the heart of everything we do.",
    icon: "💖",
  },
];
